export const SIZES = {
  UPDATED: 26,
  EDITOR: 41,
  TYPE: 33,
};
